module.exports = __webpack_public_path__ + "assets/images/box/mlink-logo@2x.png";